/*
 * Copyright © 2024-2026 symecode.com. All rights reserved.
 * 
 * This source code is proprietary and confidential.
 * Unauthorized copying, modification, or distribution is prohibited.
 */


import React from 'react';
import { Company } from '../../types';
import './Modal.css';

interface CompanyModalProps {
  company: Company;
  onClose: () => void;
}

const CompanyModal: React.FC<CompanyModalProps> = ({ company, onClose }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Company Details</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <div className="detail-grid">
            <div className="detail-row">
              <span className="detail-label">Company Name:</span>
              <span className="detail-value">{company.name}</span>
            </div>
            {company.email && (
              <div className="detail-row">
                <span className="detail-label">Email:</span>
                <span className="detail-value">{company.email}</span>
              </div>
            )}
            {company.phoneNumber && (
              <div className="detail-row">
                <span className="detail-label">Phone:</span>
                <span className="detail-value">{company.phoneNumber}</span>
              </div>
            )}
            {company.contactNotes && (
              <div className="detail-row">
                <span className="detail-label">Contact Notes:</span>
                <span className="detail-value">{company.contactNotes}</span>
              </div>
            )}
          </div>
        </div>
        <div className="modal-footer">
          <button className="button button-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompanyModal;
